import type { ReactNode } from 'react';

/**
 * Auth sayfalarının (Login/Register/Forgot/Reset) ortak layout'u.
 * Solda branding paneli, sağda form alanı (mobilde tek sütun).
 */
export function AuthLayout({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title: string;
  subtitle?: string;
}) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Sol: branding */}
      <div className="hidden lg:flex flex-col justify-between bg-gradient-to-br from-primary to-primary-700 p-12 text-white">
        <div className="flex items-center gap-3">
          <img src="/zo/zed.png" alt="" className="h-12 w-auto select-none" draggable={false} />
          <div>
            <div className="text-2xl font-bold tracking-tight">Zoprey CRM</div>
            <div className="mt-1 text-sm opacity-80">
              KOBİ için bulut tabanlı CRM
            </div>
          </div>
        </div>
        <div>
          <p className="text-3xl font-light leading-tight max-w-md">
            "Müşterilerini takip et, Excel'i unut."
          </p>
          <p className="mt-4 text-sm opacity-80 max-w-md">
            5 dakikada kurulur. KVKK uyumlu. WhatsApp + e-posta + kalvyenin
            yetmediği her yerde yanında.
          </p>
        </div>
        <div className="text-xs opacity-60">
          Türkiye'de hazırlandı 🇹🇷
        </div>
      </div>

      {/* Sağ: form */}
      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="lg:hidden text-center mb-8">
            <img src="/zo/zed.png" alt="" className="mx-auto mb-2 h-10 w-auto select-none" draggable={false} />
            <div className="text-2xl font-bold tracking-tight text-primary">
              Zoprey CRM
            </div>
          </div>
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {subtitle && (
            <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>
          )}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
